import { createApp } from "vue";
import App from "@/App.vue";
import "@/assets/styles/tailwind.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons"; // Removed specific faSearch import
import router from "@/router";
import "aos/dist/aos.css";
import Aos from "aos";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { useMotions } from "@vueuse/motion";

library.add(fas); // Add all solid icons

Aos.init({ once: true });

const app = createApp(App);

app.use(router);
app.use(useMotions);
app.use(Toast, {
  position: POSITION.TOP_CENTER,
  timeout: 5000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  toastClassName:
    "rounded-2xl shadow-lg border-2 border-gray-200 bg-gray-800 text-white font-semibold p-4",
  bodyClassName: "text-sm",
});

app.component("font-awesome-icon", FontAwesomeIcon);

app.mount("#app");
